export default {
    methods: {
        getDpOptions(view = 'days', futureDates = true, hasYear = true) {
            return {
                format: hasYear ? 'DD.MM.YYYY' : 'DD.MM',
                viewMode: view,
                // inline: true,
                maxDate: futureDates ? false : new moment(),
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'bottom',
                },
                icons: {
                    previous: 'icon icon-arrow-left',
                    next: 'icon icon-arrow-right',
                    // date: 'icon icon-arrow-left',
                    // time: '',
                    // up: '',
                    // down: '',
                    // today: '',
                    // clear: '',
                    // close: ''
                }
            }
        },
    },
};
